import { StyleSheet } from 'aphrodite'
export default StyleSheet.create({
  alert: {
    position: 'absolute',
    right: '1%',
    bottom: '10%',
    display: 'flex',
    alignItems: 'flex-start',
  },
  heading: {
    marginRight: '.5em',
    fontSize: '1.2em',
  },
})
